import { useNavigate } from 'react-router-dom';
import styles from './Report.module.css';

function Report() {
    const navigate = useNavigate();

    const reportsList = [
        {
            id: 'bird-period',
            title: '📊 Relatório de Reprodução por Ave e Período',
            description: 'Acompanhe a quantidade de reproduções, posturas, ovos (botados/galados) e filhotes de uma ave em um determinado período.',
            path: '/report/bird-period',
            available: true
        },
        {
            id: 'flock-genealogy',
            title: '🌳 Genealogia',
            description: ' Visualize a árvore genealógica do plantel com pais, avós, bisavós, trisavós até a 4ª geração.',
            path: '/report/genealogy',
            available: true // Para implementarmos a seguir
        },
        {
            id: 'reproduction-performance',
            title: '🐣 Desempenho Reprodutivo Geral',
            description: 'Métricas globais de taxas de eclosão, ovos totais e eficiência por gaiola.',
            path: '/report/reproduction',
            available: false // Para implementarmos a seguir
        },
        {
            id: 'financial-report',
            title: '💵 Relatório Financeiro',
            description: 'Acompanhe o registro de transações de aves vendidas e compradas a partir de um período selecionado.',
            path: '/report/financial',
            available: false
        }
        
    ];

    return (
        <section className={styles.container}>
            <div className={styles.header}>
                <h2>📈 Central de Relatórios</h2>
                <p>Selecione abaixo o relatório que deseja consultar e analisar.</p>
            </div>

            <div className={styles.grid}>
                {reportsList.map((report) => (
                    <div key={report.id} className={styles.card}>
                        <h3>{report.title}</h3>
                        <p>{report.description}</p>
                        <button
                            className={report.available ? styles.btn_primary : styles.btn_disabled}
                            disabled={!report.available}
                            onClick={() => report.available && navigate(report.path)}
                        >
                            {report.available ? 'Acessar Relatório' : 'Em Breve'}
                        </button>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Report;